export function containsHTML(value) {
  const htmlTagRegex = /<[^>]+>/g;
  if (typeof value === "string") {
    return htmlTagRegex.test(value);
  }
  if (Array.isArray(value)) {
    return value.some((item) => typeof item === "string" && htmlTagRegex.test(item));
  }
  return false;
}

export function createMarkup(content) {
  return { __html: content };
}

export function isNotEmpty(value) {
  if (value === null || value === undefined) return false;

  if (typeof value === "string") {
    return value.trim() !== "";
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }

  return true;
}